module.exports = __webpack_public_path__ + "img/DownloadApp.5209db75.png";